/** Whether a key press should move focus to the search: `/`, outside any field. */
export function isSearchShortcut(
    event: Pick<KeyboardEvent, "key" | "metaKey" | "ctrlKey" | "altKey">,
    target: EventTarget | null,
): boolean {
    if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey) return false;
    const element = target as HTMLElement | null;
    const tag = element?.tagName;
    return !(
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        element?.isContentEditable
    );
}
